/**
 * Rücksprung nach dem Login (Okt 2026).
 *
 * Vorher landete jede Anmeldung fest auf /app: Ein Link aus dem Chat mit einem
 * KI-Assistenten („In EachOtter öffnen“) oder die Verbindungsseite /connect verlor
 * ihr Ziel, sobald man erst noch angemeldet werden musste.
 *
 * Erlaubt sind nur interne, relative Pfade mit einem der Präfixe unten. Alles
 * andere (absolute URLs, //host, Backslashes, Punkt-Segmente, Steuerzeichen) wird
 * verworfen, damit der Parameter kein offener Redirect wird.
 */
export const RETURN_PATH_PREFIXES = [
  '/connect',
  '/app',
  '/session/',
  '/aura-stats',
  '/dashboard/teacher',
  '/account-settings',
  '/chat/',
];

const MAX_LENGTH = 512;
const ALLOWED_CHARS = /^\/[A-Za-z0-9\-._~%!$&'()*+,;=:@/?]*$/;

const hasUnsafeSegments = (path) => /\/\.{1,2}(\/|$|\?)/.test(path) || path.includes('//') || path.includes('\\');

/**
 * @param {unknown} raw  z. B. `next` aus der Query oder `location.state.from`
 * @returns {string|null}  sicherer interner Pfad oder null
 */
export const safeReturnPath = (raw) => {
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > MAX_LENGTH) return null;
  if (!raw.startsWith('/') || raw.startsWith('//') || !ALLOWED_CHARS.test(raw)) return null;
  if (hasUnsafeSegments(raw)) return null;

  let decoded;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return null;
  }
  const hasControlChars = [...decoded].some((c) => c.charCodeAt(0) < 0x20 || c.charCodeAt(0) === 0x7f);
  if (hasUnsafeSegments(decoded) || hasControlChars) return null;

  const [pathname] = raw.split('?');
  const allowed = RETURN_PATH_PREFIXES.some((prefix) => (prefix.endsWith('/')
    ? pathname.startsWith(prefix) && pathname.length > prefix.length
    : pathname === prefix || pathname.startsWith(`${prefix}/`)));
  return allowed ? raw : null;
};

export default safeReturnPath;
